export default "__VITE_ASSET__BqCSezmf__"